"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glCore = require("@capture/gl-core");

class PatternBaseGLFilter extends _glCore.GLFilter {
  constructor(...args) {
    super(...args);
    this.zoom = 4.0;
    this.greyScaleEnabled = false;
    this.greyLevels = 16.0;
    this.blackWhiteThreshold = 0.5;
  }

  initUniformLocations(gl, program) {
    var uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.zoom = gl.getUniformLocation(program, 'zoom');
    uniformLocations.greyScale = gl.getUniformLocation(program, 'greyScale');
    uniformLocations.aspect = gl.getUniformLocation(program, 'aspect');
    uniformLocations.greyLevels = gl.getUniformLocation(program, 'greyLevels');
    uniformLocations.blackWhiteThreshold = gl.getUniformLocation(program, 'blackWhiteThreshold');
    return uniformLocations;
  }

  willDraw(gl, uniformLocations, attributeLocations, flip) {
    gl.uniform1f(uniformLocations.zoom, this.zoom);
    gl.uniform1f(uniformLocations.greyScale, this.greyScaleEnabled);
    gl.uniform1f(uniformLocations.greyLevels, this.greyLevels);
    gl.uniform1f(uniformLocations.blackWhiteThreshold, this.blackWhiteThreshold);
    super.willDraw(gl, uniformLocations, attributeLocations, flip);
  }

  onViewSizeChanged(gl, width, height) {
    gl.uniform1f(this.uniformLocations.aspect, 1.0 * width / height);
  }

}

exports.default = PatternBaseGLFilter;